import { getDatabase } from 'database';

export const IS_ONLINE: string = 'isOnline';
export const IS_SIMULATING_OFFLINE_MODE: string = 'isSimulatingOfflineMode';

export async function getStatus(): Promise<boolean> {
  const db = await getDatabase();
  return await db.read(db.config.indexes.ConnectionStatus, IS_ONLINE) as boolean;
}

export async function setStatus(isOnline: boolean) {
  const db = await getDatabase();
  const status = await db.read(db.config.indexes.ConnectionStatus, IS_ONLINE);
  if (status !== undefined) {
    await db.put(db.config.indexes.ConnectionStatus, isOnline, IS_ONLINE);
  } else {
    await db.add(db.config.indexes.ConnectionStatus, isOnline, IS_ONLINE);
  }
}

export async function getOfflineModeSimulation(): Promise<boolean> {
  const db = await getDatabase();
  return await db.read(db.config.indexes.ConnectionStatus, IS_SIMULATING_OFFLINE_MODE) as boolean;
}

export async function setOfflineModeSimulation(isSimulatingOfflineMode: boolean) {
  const db = await getDatabase();
  const isOfflineMode = await db.read(db.config.indexes.ConnectionStatus, IS_SIMULATING_OFFLINE_MODE);
  if (isOfflineMode !== undefined) {
    await db.put(db.config.indexes.ConnectionStatus, isSimulatingOfflineMode, IS_SIMULATING_OFFLINE_MODE);
  } else {
    await db.add(db.config.indexes.ConnectionStatus, isSimulatingOfflineMode, IS_SIMULATING_OFFLINE_MODE);
  }
}


// WEBPACK FOOTER //
// ./src/services/connection-status-service.ts